import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { isTartarSauceWord } from '../wordAnalysis'

export const tartarSauceCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return isAcceptedWordEntry(entry) && isTartarSauceWord(entry.word)
}
